import styled from 'styled-components';
import { media } from '../../../../ui';
export const Carrier = styled.div.withConfig({
  displayName: "Style__Carrier",
  componentId: "sc-38rwvt-0"
})(["margin-top:20px;margin-bottom:20px;overflow:hidden;border-radius:6px;box-shadow:0 2px 4px rgba(0,0,0,0.15);"]);
export const Textarea = styled.textarea.withConfig({
  displayName: "Style__Textarea",
  componentId: "sc-38rwvt-1"
})(["min-height:100px;resize:vertical;", ";"], media.xs`
    font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.md}px
  `);
export const Content = styled.div.withConfig({
  displayName: "Style__Content",
  componentId: "sc-38rwvt-2"
})(["padding:15px 20px 15px 30px;background-color:", ";border-bottom-right-radius:6px;border-bottom-left-radius:6px;", ";", ";"], ({
  theme: {
    color
  }
}) => color.white, media.sm`
    padding: 20px;
  `, media.xs`
    padding: 15px;
  `);
export const Title = styled.div.withConfig({
  displayName: "Style__Title",
  componentId: "sc-38rwvt-3"
})(["font-size:", "px;", ";"], ({
  theme: {
    fontSize
  }
}) => fontSize.h5, media.xs`
    margin-bottom: 5px;
    font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.h6}px;
    line-height: 1.22;
  `);
export const Description = styled.p.withConfig({
  displayName: "Style__Description",
  componentId: "sc-38rwvt-4"
})(["margin-bottom:16px;color:", ";opacity:0.4;", ";"], ({
  theme: {
    color
  }
}) => color.black, media.xs`
    font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.sm}px;
    line-height: 1.17;
  `);
export const Row = styled.div.withConfig({
  displayName: "Style__Row",
  componentId: "sc-38rwvt-5"
})(["display:flex;align-items:start;margin-right:-20px;margin-left:-20px;", ";"], media.xs`
    display: block;
    margin-left: -15px;
    margin-right: -15px;
  `);
export const Column = styled.div.withConfig({
  displayName: "Style__Column",
  componentId: "sc-38rwvt-6"
})(["flex:1;flex-basis:50%;padding-right:20px;padding-left:20px;", ";"], media.xs`
    flex-basis: 100%;
  `);
export const ScaleUpper = styled.div.withConfig({
  displayName: "Style__ScaleUpper",
  componentId: "sc-38rwvt-7"
})(["display:flex;align-items:center;justify-content:space-between;", ";"], media.xs`
    font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.sm}px
  `);
export const TextPrimary = styled.div.withConfig({
  displayName: "Style__TextPrimary",
  componentId: "sc-38rwvt-8"
})(["color:", ";"], ({
  theme: {
    color
  }
}) => color.primary);
export const Rating = styled.div.withConfig({
  displayName: "Style__Rating",
  componentId: "sc-38rwvt-9"
})(["", ";", ";"], media.xs`
    margin-top: 30px;
    margin-bottom: 40px;
  `, media.xxs`
    margin: 0;
  `);
export const ColumnCount = styled(Column).withConfig({
  displayName: "Style__ColumnCount",
  componentId: "sc-38rwvt-10"
})(["column-count:2;", ";"], media.sm`
     column-count: 1;
  `);
export const CheckboxContainer = styled.div.withConfig({
  displayName: "Style__CheckboxContainer",
  componentId: "sc-38rwvt-11"
})(["margin-bottom:12px;"]);
export const CheckboxLabel = styled.label.withConfig({
  displayName: "Style__CheckboxLabel",
  componentId: "sc-38rwvt-12"
})(["&:before{width:16px;height:16px;margin-top:3px;border-radius:2px;}"]);